// extracted by css-extract-rspack-plugin
export default {"activeView":"ViewList_activeView__R8YKt"};